// src/views/kiddo-games/recognize2/WordFromList.tsx
// Kopia src/components/Recognize/WordFromList.tsx — tylko dla Rozpoznaj Easy.
// Nad ramką z polskim słowem stoi obrazek słowa w osobnej ramce, jak w grze Powtórz.
import React, { FC } from 'react';
import { FitText } from '../../../components/FitText/FitText';
import classes from './WordFromList.module.less';

type CardProps = {
  id: any,
  content: string,
  image?: string,
};

export const WordFromList: FC<CardProps> = ({
  content, id, image,
}) => (
  <>
    {/* Ramka stoi też bez obrazka, jak w Powtórz — karty i przyciski nie skaczą między słowami */}
    <div className={classes.pict}>
      {/* alt pusty — to samo słowo stoi pod spodem jako napis */}
      {image && <img src={image} alt="" />}
    </div>
    {/* Długi zwrot dostaje mniejszą czcionkę, żeby zmieścił się w karcie (na telefonie) */}
    <FitText
      className={classes.word}
      id={id}
    >
      {content}
    </FitText>
  </>
);

export default WordFromList;
